import { render, staticRenderFns } from "./LocationFacilities.vue?vue&type=template&id=b86a1d5c&scoped=true"
import script from "./LocationFacilities.vue?vue&type=script&lang=ts"
export * from "./LocationFacilities.vue?vue&type=script&lang=ts"
import style0 from "./LocationFacilities.vue?vue&type=style&index=0&id=b86a1d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86a1d5c",
  null
  
)

export default component.exports